export default __webpack_public_path__ + "static/contemplating-44e546575e9aad08c1b974122f7e54b2.png";